import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import type { ModalProps } from 'antd';
import { IAddress } from 'base/interfaces/address';
import AddressForm, { AddressFormProps } from '@base/account/address/AddressFormPc';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';

export type IModalState = {
    visible: boolean;
    title?: string;
    address?: IAddress;
    hideEmail?: boolean;
}

export type AddressFormModalProps = IModalState & {
    className?: string;
    onSubmit?: (address: IAddress) => Promise<void>;
    onCancel: () => void;
    onSubmitSelf?: (data: IAddress) => Promise<void>; // 自己提交 不走默认的接口
    modalFormProps?: {
        modal?: ModalProps;
        form?: AddressFormProps;
    };
};

const AddressFormModal: React.FC<AddressFormModalProps> = props => {
    const { t } = useTrans();
    const {
        visible,
        address,
        className,
        onSubmit,
        onCancel,
        title = t('web_address_shipping_address_title'),
        hideEmail,
        onSubmitSelf,
        modalFormProps
    } = props;
    const [counter, setCounter] = useState<number>(0);
    const { modal: modalProps, form: formProps } = modalFormProps || { modal: {}, form: {} }

    useEffect(() => {
        if (visible) {
            setCounter(counter + 1);
        }
    }, [visible]);

    return (
        <Modal
            destroyOnClose
            title={title}
            width={720}
            open={visible}
            onCancel={onCancel}
            footer={false}
            maskClosable={false}
            centered
            closeIcon={<Iconfont className={'icon-x'}/>}
            {...modalProps}
        >
            <AddressForm
                className={className}
                address={address}
                // isSetDefault={true}
                onSubmit={onSubmit}
                onCancel={onCancel}
                onSubmitSelf={onSubmitSelf}
                counter={counter}
                hideEmail={hideEmail}
                {...formProps}
            />
        </Modal>
    )
};

export default AddressFormModal;